/**
 * Constants for Device Import Dialog.
 * Defines API endpoints, file constraints, import statuses, and display mappings.
 */

export const IMPORT_CSV_URL = '/ipm/v1/monitoredDeviceImport/importCSV';
export const IMPORT_STATUS_URL = '/ipm/v1/monitoredDeviceImport/importStatus';

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB
export const MAX_FILE_SIZE_MB = 20;
export const POLL_INTERVAL_MS = 1000;
export const ACCEPTED_FILE_TYPES = '.csv,.txt';

export const STATUS_PROCESSING = 'processing';
export const STATUS_SUCCESS = 'success';
export const STATUS_PARTIAL_SUCCESS = 'partialSuccess';
export const STATUS_FAILED = 'failed';

export const STATUS_DISPLAY_MAP = {
    [STATUS_SUCCESS]: 'Success',
    [STATUS_PARTIAL_SUCCESS]: 'Partial Success',
    [STATUS_FAILED]: 'Failed',
};

export const ERROR_TYPES = {
    FILE_SIZE: 'fileSize',
    FILE_EXISTENCE: 'fileExistence',
};
